const VERSION = "1.6.23" //版本号

let env = "108";
// let baseUrl = "http://10.10.80.29:8081" //基础api域名,环境
// let baseImgUrl ='http://10.10.80.24/shortTimeApi/sys/common/static';

let baseUrl = "https://www.chanu9999.com/api" //生产
let baseImgUrl ='https://www.chanu9999.com/shortTimeApi/sys/common/static';

module.exports = {
  baseUrl,
  VERSION,
  env,
  baseImgUrl
}



// WEBPACK FOOTER //
// ./src/api/config.js